@let items = (coins$ | async) ?? [];

<lib-multiselect
  titleTranslationKey="monitoring.coins"
  chosenTranslationKey="monitoring.coins-chosen"
  [options]="items"
  [formControl]="controlEntity"
  [isSearchDisplayed]="true"
  [isOptionIconDisplayed]="displayIcons"
/>
